import { Workbox } from "workbox-window";

export function registerServiceWorker() {
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    const wb = new Workbox("/sw.js");
    const pageLoadTime = Date.now();
    const POSTPONE_KEY = "sw-update-postponed";
    const POSTPONE_DURATION = 60 * 60 * 1000; // 60 minutes in milliseconds
    const APP_VERSION_KEY = "app-version";

    const shouldShowPrompt = () => {
      const postponedUntil = sessionStorage.getItem(POSTPONE_KEY);
      if (postponedUntil && Date.now() < parseInt(postponedUntil, 10)) {
        console.log("Update prompt is postponed.");
        return false;
      }

      const timeSinceLoad = Date.now() - pageLoadTime;
      // Only show prompt if the page has been open for more than 60 seconds.
      return timeSinceLoad > 60 * 1000;
    };

    // This event fires when a new service worker is waiting to activate.
    wb.addEventListener("waiting", () => {
      console.log("A new service worker is waiting to activate.");
      if (shouldShowPrompt()) {
        const updateAccepted = confirm(
          "A new version of the application is available. Would you like to reload to apply the update?"
        );

        if (updateAccepted) {
          sessionStorage.removeItem(POSTPONE_KEY);
          // This will activate the new service worker.
          wb.messageSkipWaiting();
        } else {
          // Postpone the next prompt.
          const postponedUntil = Date.now() + POSTPONE_DURATION;
          sessionStorage.setItem(POSTPONE_KEY, postponedUntil.toString());
          console.log(
            `Update prompt postponed for ${POSTPONE_DURATION / 60000} minutes.`
          );
        }
      }
    });

    // This event fires when the new service worker has taken control.
    wb.addEventListener("controlling", () => {
      console.log(
        "New service worker is now controlling the page. Reloading..."
      );
      // Reload the page to use the updated assets.
      window.location.reload();
    });

    // Register the service worker.
    wb.register()
      .then((registration) => {
        if (registration) {
          console.log(
            "Service worker registered. Starting periodic update check."
          );
          // Periodically check for updates every 60 seconds.
          setInterval(async () => {
            console.log("Checking for app updates...");
            try {
              const response = await fetch("/status");
              if (response.ok) {
                const data = await response.json();
                const newVersion = data.version;
                const currentVersion = localStorage.getItem(APP_VERSION_KEY);

                if (currentVersion && newVersion !== currentVersion) {
                  console.log(`New version detected (${newVersion}). Updating...`);
                  const cacheKeys = await caches.keys();
                  await Promise.all(cacheKeys.map((key) => caches.delete(key)));
                  localStorage.setItem(APP_VERSION_KEY, newVersion);
                  await registration.unregister();
                  window.location.reload();
                } else if (!currentVersion) {
                  localStorage.setItem(APP_VERSION_KEY, newVersion);
                }
              }
            } catch (error) {
              console.error("Failed to check for updates:", error);
            }
          }, 60 * 1000);
        }
      })
      .catch((error) => {
        console.error("Service worker registration failed:", error);
      });
  }
}
